export const DEXNET_DISCOUNT = 1; // 0.8;
export const SERVICE_TYPES = ["DEX_CLOUD", "DEX_PN", "DEX_MOBILE", "DEX_CARDS", "DEX_SAFE", "DEX_POINT"];
export const USER_ROLES = {
    NEW_USER: 'NEW_USER',
    OLD_USER: 'OLD_USER',
    CLIENT: 'CLIENT',
    RESIDENT:'RESIDENT',
    RESIDENT_LIMITED: 'RESIDENT_LIMITED'
}
